/**
 * Created by Kaku.Guo on 2018/10/26.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { RatingBoard, Link } from '../index';

const AssetTileRating = (props) => {
    const {
        data: {
            rating = {},
            urlSlug,
            catalogItemId,
            customAttributes
        },
        isLauncher
    } = props;

    const hasBuyLink = customAttributes && 'BuyLink' in customAttributes;
    if (hasBuyLink) {
        return null;
    }

    const renderReviewBtn = children => {
        let link = '';
        if (urlSlug) {
            link = `product/${urlSlug}`;
        } else if (catalogItemId) {
            link = `item/${catalogItemId}`;
        }
        return <Link to={`${link}/reviews`}>{children}</Link>;
    };

    return <RatingBoard data={rating} isLauncher={isLauncher} size={18} renderReviewBtn={renderReviewBtn} />;
};

AssetTileRating.propTypes = {
    data: PropTypes.object,
    isLauncher: PropTypes.bool
};
export default AssetTileRating;